export default __webpack_public_path__ + "static/desk01-30342094b478f4f3540f232e9decde36.png";